export * from './formato';
export * from './nombrePersonal';
export * from './texto';
export * from './objetos';



// WEBPACK FOOTER //
// ./src/utilidades/index.ts